import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Loader } from 'google-maps';

@Component
export class MapLocation extends ThemeComponent {
    private mapId:HTMLElement | null = document.getElementById('map-attach');

    init() {
        void this.map();
    }

    async map() {
        const key = 'AIzaSyBZFQaHeMPV_Z1fD4IXhN7OvJ6ts2JSyZk';
        const loader = new Loader(key);
        const google = await loader.load();
        const latlng = {lat: 52.474922, lng: -1.866608};

        if (this.mapId) {
            const map = new google.maps.Map((this.mapId), {
                center: latlng,
                zoom: 17,
            });

            new google.maps.Marker({
                position: latlng,
                map: map
            });
        }
    }
}
